import DOMPurify from 'dompurify';

/**
 * DOMPurify global configuration
 * Runs once when this module is imported
 */

DOMPurify.setConfig({
  ADD_ATTR: ['target', 'rel']
});

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName !== 'A') return;

  const target = node.getAttribute('target');

  // Strip all target values except "_blank"
  if (target && target !== '_blank') {
    node.removeAttribute('target');
    return;
  }

  // Secure allowed _blank
  if (target === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const sanitizeDirective = (app) => {
  app.directive('sanitize', {
    beforeMount(el, binding) {
      el.innerHTML = DOMPurify.sanitize(binding.value);
    },
    updated(el, binding) {
      el.innerHTML = DOMPurify.sanitize(binding.value);
    }
  });
};

export default sanitizeDirective;
